(function () {
    'use strict';

    angular
        .module('blocks.filters')
        .filter('utcToLocalTime', utcToLocalTime);


    function utcToLocalTime() {
        return function (input) {
            var local = moment.utc(input).toDate();
            return moment(local).format("hh:mm A");
        }
    }

})();

